import { render, staticRenderFns } from "./includeIcon.vue?vue&type=template&id=31f22302&"
import script from "./includeIcon.vue?vue&type=script&lang=js&"
export * from "./includeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports